export const styles = theme => ({
  viewportAligned: {
    '&.__react_component_tooltip.place-top:after, &.__react_component_tooltip.place-bottom:after': {
      left: 'var(--tooltip-arrow-left, 50%) !important',
    },
  },
  tooltip: {
    maxWidth: '290px',
    width: 'auto',
    boxSizing: 'border-box',
    boxShadow: '4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    borderRadius: '10px',
    zIndex: 9999,
    opacity: 1,
    textAlign: 'start',
    fontWeight: 'normal',
    fontSize: '14px',
    padding: 10,
    backgroundColor: 'var(--color-text-secondary)',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    '&.tooltip-ai.__react_component_tooltip.place-top:after': {
      left: '86% !important',
    }
  },
  tooltipWrap: {
    cursor: 'pointer',
    display: 'inline-flex',
    marginLeft: 4,
  },
})
